import {
  GET_CUSTOMER_ORDERING_PREFERENCES_REQUESTED,
  GET_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  GET_CUSTOMER_ORDERING_PREFERENCES_FAILED,
  CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED,
  CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED,
  REMOVE_CUSTOMER_ORDERING_PREFERENCE_REQUESTED,
  REMOVE_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED,
  REMOVE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED,
  REMOVE_CUSTOMER_ORDERING_PREFERENCE_FAILED,
  CREATE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED
} from './constants'
import api from '../../utils/api'

export const createOptimisticCustomerOrderingPreferenceSucceeded = (payload) => ({
  type: CREATE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  payload
})

export const getCustomerOrderingPreferencesRequested = () => ({
  type: GET_CUSTOMER_ORDERING_PREFERENCES_REQUESTED
})

export const getCustomerOrderingPreferencesSucceeded = (payload) => ({
  type: GET_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  payload
})

export const getCustomerOrderingPreferencesFailed = () => ({
  type: GET_CUSTOMER_ORDERING_PREFERENCES_FAILED
})

export const createCustomerOrderingPreferencesRequested = () => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_REQUESTED,
})

export const createCustomerOrderingPreferencesSucceeded = (payload) => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_SUCCEEDED,
  payload
})

export const createCustomerOrderingPreferencesFailed = (payload) => ({
  type: CREATE_CUSTOMER_ORDERING_PREFERENCES_FAILED,
  payload
})

export const removeCustomerOrderingPreferenceRequested = () => ({
  type: REMOVE_CUSTOMER_ORDERING_PREFERENCE_REQUESTED,
})

export const removeCustomerOrderingPreferenceSucceeded = (payload) => ({
  type: REMOVE_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED,
  payload
})

export const removeOptimisticCustomerOrderingPreferenceSucceeded = (payload) => ({
  type: REMOVE_OPTIMISTIC_CUSTOMER_ORDERING_PREFERENCE_SUCCEEDED,
  payload
})

export const removeCustomerOrderingPreferenceFailed = (preferenceUuid) => ({
  type: REMOVE_CUSTOMER_ORDERING_PREFERENCE_FAILED,
})

export const removeCustomerOrderingPreference = (preferenceUuid) => dispatch => {
  dispatch(removeCustomerOrderingPreferenceRequested())
  dispatch(removeOptimisticCustomerOrderingPreferenceSucceeded(preferenceUuid))

  return api
    .removeCustomerOrderingPreference(preferenceUuid)
    .then(response => dispatch(removeCustomerOrderingPreferenceSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(removeCustomerOrderingPreferenceFailed(preferenceUuid)))
}

export const createCustomerOrderingPreferences = (customerId, payload) => dispatch => {
  dispatch(createCustomerOrderingPreferencesRequested())
  dispatch(createOptimisticCustomerOrderingPreferenceSucceeded(payload))

  return api
    .createCustomerOrderingPreference(customerId, payload)
    .then(response => dispatch(createCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(createCustomerOrderingPreferencesFailed(payload)))
}

export const createNoOptimisticCustomerOrderingPreferences = (customerId, payload) => dispatch => {
  dispatch(createCustomerOrderingPreferencesRequested())

  return api
    .createCustomerOrderingPreference(customerId, payload)
    .then(response => dispatch(createCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(createCustomerOrderingPreferencesFailed(payload)))
}

export const loadCustomerOrderingPreferences = (customerId, venueUuid) => dispatch => {
  dispatch(getCustomerOrderingPreferencesRequested())

  return api
    .fetchCustomerOrderingPreferences(customerId, venueUuid)
    .then(response => dispatch(getCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(getCustomerOrderingPreferencesFailed()))
}

export const loadAllCustomerOrderingPreferences = (venueUuid) => dispatch => {
  dispatch(getCustomerOrderingPreferencesRequested())

  return api
    .fetchAllCustomerOrderingPreferences(venueUuid)
    .then(response => dispatch(getCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(getCustomerOrderingPreferencesFailed()))
}

export const loadAllCustomerOrderingPreferencesByEventId = (salesEventId) => dispatch => {
  dispatch(getCustomerOrderingPreferencesRequested())

  return api
    .fetchAllCustomerOrderingPreferencesByEventId(salesEventId)
    .then(response => dispatch(getCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(getCustomerOrderingPreferencesFailed()))
}

export const loadAllCustomerOrderingPreferencesByEventIdByCustomerId = (salesEventId, customerId) => dispatch => {
  dispatch(getCustomerOrderingPreferencesRequested())

  return api
    .fetchAllCustomerOrderingPreferencesByEventIdByCustomerId(salesEventId, customerId)
    .then(response => dispatch(getCustomerOrderingPreferencesSucceeded(response.data.orderingPreferences)))
    .catch(() => dispatch(getCustomerOrderingPreferencesFailed()))
}
